import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { Search, MapPin, ChevronRight } from "lucide-react";
import { usePageMeta } from "../lib/seo";
import { STATES, statePath, cityPath } from "../lib/states";
import { Container, Reveal } from "../components/site/Reveal";
import { PageHero } from "./Bulk";

const StatesIndex = () => {
  const [q, setQ] = useState("");
  usePageMeta({
    title: "Areas We Serve: All 50 States | StripWise",
    description: "StripWise accepts sealed, unexpired testing supplies by mail from every US state. Find your state for free quote and prepaid shipping details.",
    path: "/sell-test-strips",
  });
  const list = useMemo(() => STATES.filter((s) => `${s.name} ${s.abbr} ${s.cities.join(" ")}`.toLowerCase().includes(q.toLowerCase())), [q]);
  return (
    <>
      <PageHero eyebrow="Areas We Serve" title="We Serve All 50 States" text="We buy sealed diabetic supplies by mail from anywhere in the USA. Pick your state to see how it works where you live." />
      <section className="pb-20">
        <Container>
          <div className="relative max-w-md">
            <Search size={17} className="absolute left-4 top-1/2 -translate-y-1/2 text-[#8a9a97]" />
            <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search your state or city" className="w-full rounded-full border border-[#dcebe8] bg-white py-3 pl-11 pr-4 text-[15px] outline-none focus:border-[#0e8c7f]" data-testid="states-search" />
          </div>
          <Reveal className="mt-8 grid gap-3 sm:grid-cols-2 lg:grid-cols-4" data-testid="states-grid">
            {list.map((s) => (
              <Link key={s.slug} to={statePath(s)} onClick={() => window.scrollTo(0, 0)} className="sw-card group flex items-center gap-3 p-4" data-testid="state-link">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#d3f6ee] text-[13px] font-bold text-[#0b6f65]">{s.abbr}</span>
                <span className="min-w-0 flex-1">
                  <span className="block font-semibold text-[#0f2e2a]">{s.name}</span>
                  <span className="block truncate text-[12.5px] text-[#6b7c79]">{s.cities.slice(0, 3).join(" · ")}</span>
                </span>
                <ChevronRight size={17} className="text-[#a9bbb7] transition-transform group-hover:translate-x-0.5" />
              </Link>
            ))}
          </Reveal>
          <div className="mt-14">
            <h2 className="text-[22px] font-bold text-[#0f2e2a]">Popular cities</h2>
            <div className="mt-4 flex flex-wrap gap-2" data-testid="city-index">
              {list.flatMap((s) => s.cities.slice(0, 3).map((c) => (
                <Link key={`${s.slug}-${c}`} to={cityPath(s, c)} onClick={() => window.scrollTo(0, 0)} className="rounded-full border border-[#d6efe9] bg-white px-3 py-1.5 text-[13px] font-medium text-[#0b6f65] hover:border-[#0e8c7f]">{c}, {s.abbr}</Link>
              )))}
            </div>
          </div>
          {!list.length && <p className="mt-8 flex items-center gap-2 text-[#6b7c79]"><MapPin size={16} />No match — but we still buy anywhere in the USA. Chat with us!</p>}
        </Container>
      </section>
    </>
  );
};

export default StatesIndex;
